import { render, staticRenderFns } from "./SideSwipeBar.vue?vue&type=template&id=4ad2ce21"
import script from "./SideSwipeBar.vue?vue&type=script&lang=js"
export * from "./SideSwipeBar.vue?vue&type=script&lang=js"
import style0 from "./SideSwipeBar.vue?vue&type=style&index=0&id=4ad2ce21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports